export default "__VITE_ASSET__BrCF1eoN__"